import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";

import indexRoutes from "routes/index.jsx";

import "assets/scss/material-kit-react.css?v=1.1.0";
// https://medium.com/@chowdhury.madhumita1/aws-s3-react-spa-es6-google-crawler-and-seo-how-to-make-them-work-together-fd980cb4947f
var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist} basename={process.env.PUBLIC_URL}>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} key={key} component={prop.component} />;
      })}
    </Switch>
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js